import React from 'react';
import { IconButton } from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

const ClearFiltersBtn: React.FC<ClearFiltersBtnProps> = props => {
    return (
        <IconButton
            color='secondary'
            title='Wyczyść filtry'
            onClick={ props.onClearFiltersClick }
            disabled={ props.disabled }
            sx={ { height: 'fit-content' } }
        >
            <FilterAltOffIcon/>
        </IconButton>
    );
}
export default ClearFiltersBtn;

export interface ClearFiltersBtnProps {
    readonly onClearFiltersClick: () => void;
    readonly disabled?: boolean;
}